import {requestWithToken, simpleRequest} from "../apiConfigs/request";

export const fetchSkills = () => {
  return simpleRequest({
    url: '/skills/',
    method: 'GET'
  });
}

export const addSkills = (data) => {
  return requestWithToken({
    url: '/skills/',
    method: 'POST',
    data
  });
}
